import { render, staticRenderFns } from "./TelegramChatConversation.vue?vue&type=template&id=745751bc&lang=pug&"
import script from "./TelegramChatConversation.vue?vue&type=script&lang=js&"
export * from "./TelegramChatConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports